"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/components/Forms/FilledPage.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } }var _react = require('react'); var _react2 = _interopRequireDefault(_react);

var _forms = require('shared/services/forms');

require('./formsChat.scss');
















const rowMark = (row) =>
  row.result === 'refused' ? `${row.initials} R` : row.result === 'missed' ? `${row.initials} M` : row.initials

// The signed PDF's page is 215.9 mm wide; a point is 0.3528 mm.
const PDF_PAGE_MM = 215.9
const PT_MM = 0.3528
// The width of "WWWW R" in Helvetica, in ems: the widest day mark.
const WIDEST_MARK_EM = 4.776

/* A log's rows in its table, as the signed PDF stamps them (stampRows in
 * forms_completion.go): in the column for their day (1 to 31), one line each
 * down from the top of the column, or in the next empty row. */
const rowCells = (field, rows, W, H) => {
  if (!field.rows) return []
  const mine = rows.filter(row => row.field === field.id)
  const x = field.box.x * W
  const y = field.box.y * H
  const w = field.box.w * W
  const h = field.box.h * H
  if (field.rows.mode === 'day') {
    const colW = w / 31
    // At most 9 pt, and small enough that the widest mark fits a column.
    const size = Math.min((9 * PT_MM * W) / PDF_PAGE_MM, (colW * 0.95) / WIDEST_MARK_EM)
    const lineH = size * 1.25
    const stacked = new Map()
    return mine.filter(row => row.day).flatMap(row => {
      const day = row.day
      const i = _nullishCoalesce(stacked.get(day), () => ( 0))
      stacked.set(day, i + 1)
      const top = y + i * lineH
      return top + lineH > y + h ? [] : [{ key: row.id, text: rowMark(row), x: x + (day - 1) * colW, y: top, w: colW, h: lineH }]
    })
  }
  const count = Math.max(1, field.rows.count)
  const rowH = h / count
  return mine.slice(0, count).flatMap((row, i) => {
    const texts = _forms.rowCellTexts.call(void 0, field.rows.columns, row)
    const colW = w / texts.length
    return texts.map((text, c) => ({ key: `${row.id}-${c}`, text, x: x + c * colW, y: y + i * rowH, w: colW, h: rowH }))
  })
}

/* One form page with values drawn at their boxes, scaled with the page so it
 * reads the same at any width. */
const FilledPage = ({ page, pageIndex, fields, valueOf, rows = [], label, current, currentRef }) => {
  const W = page.Width || 1000
  const H = page.Height || 1294
  // About 11 pt on a letter page at most, as the PDF caps it.
  const maxFont = W * 0.018
  const cells = fields
    .filter(field => field.page === pageIndex)
    .flatMap(field => {
      if (field.type === 'rows') return rowCells(field, rows, W, H)
      const value = valueOf(field)
      if (!value) return []
      const text = field.type === 'checkbox' ? (value === 'true' ? 'X' : '') : value
      return [{ key: field.id, text, x: field.box.x * W, y: field.box.y * H, w: field.box.w * W, h: field.box.h * H }]
    })
    .filter(cell => cell.text)
  const on = current ? fields.find(field => field.id === current && field.page === pageIndex) : undefined

  return (
    _react2.default.createElement('svg', {
      className: "forms-page",
      viewBox: `0 0 ${W} ${H}`,
      style: { '--page-ratio': W / H } ,
      role: "img",
      'aria-label': label, __self: this, __source: {fileName: _jsxFileName, lineNumber: 84}}

      , _react2.default.createElement('image', { href: page.URL, x: 0, y: 0, width: W, height: H, __self: this, __source: {fileName: _jsxFileName, lineNumber: 91}} )
      ,  on && (
        _react2.default.createElement('rect', {
          ref: currentRef,
          className: "forms-page--current",
          x: on.box.x * W,
          y: on.box.y * H,
          width: on.box.w * W,
          height: on.box.h * H,
          rx: W * 0.004, __self: this, __source: {fileName: _jsxFileName, lineNumber: 93}}
        )
      ) 
      ,  cells.map(cell => {
        const text = cell.text.replace(/\n/g, ' ')
        const fontSize = Math.max(6, Math.min(cell.h * 0.75, maxFont))
        // Squeeze what would run past its box (roughly half an em a letter).
        const tooWide = text.length * fontSize * 0.55 > cell.w - 4
        return (
          _react2.default.createElement('text', {
            key: cell.key,
            className: "forms-page--value",
            x: cell.x + 2,
            y: cell.y + cell.h / 2,
            dominantBaseline: "central",
            fontSize: fontSize,
            textLength: tooWide ? Math.max(1, cell.w - 4) : undefined,
            lengthAdjust: tooWide ? 'spacingAndGlyphs' : undefined, __self: this, __source: {fileName: _jsxFileName, lineNumber: 109}}

            ,  text 
          )
        )
      })
    )
  )
}

exports. default = FilledPage
